<template>
  <div class="userinfo">
    <header-bar :name='!$route.query.works_id ? "上传短视频" : "编辑短视频信息"'></header-bar>
    <div v-if="step == 1">
      <div class="content">
        <div class="formWrap">
          <div style="padding: 0 .7rem">
            <van-uploader :after-read="afterRead" :max-size="1024 * 1024 * 1024" accept=".mp4"/>
            <img src="../img/m/add_video.png" alt="" class="add_img">
            <div class="upload_cover" v-if="startUpload">
              {{stsProgress}}%
            </div>
            <div class="add_tip">
              {{videoInfo}}
            </div>
            <div class="add_tip">
              支持mp4格式，文件最大为1G。
            </div>
          </div>
        </div>
      </div>
      <div :class="['submit_btn', file ? '' : 'disable']" @click="file ? stsUpload() : ''" v-if="stsProgress != 100">
        上传
      </div>
      <div :class="['submit_btn']" @click="step = 2" v-if="stsProgress == 100">
        下一步
      </div>
    </div>
    <div v-if="step == 2">
      <div class="content">
        <div class="formWrap">
          <div class="upload_cover_wrap">
            <van-uploader :after-read="afterReadCover" :max-size="10 * 1024 * 1024" accept=".jpg,.jpeg,.png,.gif"/>
            <div class="cover_con">
              <div class="change_cover" v-if="infoForm.video_cover">更换封面</div>
              <img :src="infoForm.video_cover ? 'https://collection2021-cos.chineseplus.net/'+infoForm.video_cover : require('../img/m/add_cover.png')" alt="" class="add_img">
            </div>
            <div class="add_tip">
              视频封面图片要求为jpg、gif、png格式，文件大小不大于10MB。
            </div>
          </div>

          <div class="formItem title clearfix">
            <div class="formName">标题</div>
            <div class="formCon">
              <textarea name="" id="" cols="10" rows="5" placeholder="请输入50字以内标题" maxlength="50" v-model="infoForm.title"></textarea>
            </div>
          </div>
          <div class="formItem note clearfix">
            <div class="formName">描述</div>
            <div class="formCon">
              <textarea name="" id="" cols="10" rows="5" placeholder="150字以内" maxlength="150" v-model="infoForm.desc"></textarea>
            </div>
          </div>
          <div class="formItem clearfix">
            <div class="formName">拍摄时间</div>
            <div class="formIcon">
              <img src="../img/m/calendar.png" alt="" class="calendar">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': firstTime}" @click="showTimePicker = true">
              {{firstTime ? '请选择' : new Date(shotTime).Format('YYYY年MM月')}}
            </div>
            <van-popup v-model="showTimePicker" position="bottom">
              <van-datetime-picker
                v-model="infoForm.time"
                type="date"
                title="选择年月日"
                @confirm="onConfirmTime"
                @cancel="showTimePicker = false"
              />
            </van-popup>
          </div>
          <div class="formItem clearfix">
            <div class="formName">国家</div>
            <div class="formIcon">
              <img src="../img/m/arrow_right.png" alt="" class="arrow">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': !infoForm.sid}" @click="showCountryPicker = true">
              {{infoForm.sid ? countryList.find(v => infoForm.sid == v.sid).cn : '请选择'}}
            </div>
            <van-popup v-model="showCountryPicker" position="bottom">
              <van-picker
                show-toolbar
                value-key='cn'
                :columns="countryList"
                @confirm="onConfirmCountry"
                @cancel="showCountryPicker = false"
              />
            </van-popup>
          </div>
          <div class="formItem clearfix">
            <div class="formName">作品分类</div>
            <div class="formIcon">
              <img src="../img/m/arrow_right.png" alt="" class="arrow">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': !infoForm.category_id}" @click="showCategoryPicker = true">
            {{infoForm.category_id ? categoryList.find(v => infoForm.category_id == v.category_id).category_name : '请选择'}}
            </div>
            <van-popup v-model="showCategoryPicker" position="bottom">
              <van-picker
                show-toolbar
                value-key='category_name'
                :columns="categoryList"
                @confirm="onConfirmCategory"
                @cancel="showCategoryPicker = false"
              />
            </van-popup>
          </div>
          <div class="formItem clearfix" v-if="infoForm.category_id">
            <div class="formName">作品话题</div>
            <div class="formIcon">
              <img src="../img/m/arrow_right.png" alt="" class="arrow">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': !infoForm.topic_id}" @click="showTopicPicker = true">
            {{infoForm.topic_id ? topicList.find(v => infoForm.topic_id == v.topic_id).topic_name : '请选择'}}
            </div>
            <van-popup v-model="showTopicPicker" position="bottom">
              <van-picker
                show-toolbar
                value-key='topic_name'
                :columns="topicList"
                @confirm="onConfirmTopic"
                @cancel="showTopicPicker = false"
              />
            </van-popup>
          </div>
        </div>
      </div>
      <div :class="['submit_btn']" @click="submitFun()">
        提交
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { Notify } from 'vant'
import headerBar from './common/headerBar'

export default {
  components: {
    headerBar
  },
  data () {
    return {
      isEdit: false,
      dialogVisible: false,
      videoUploadStep: 1, // 1:视频封面 2：视频文件 3：视频信息
      fileList: [], // 选择视频文件
      videoFilePicList: [], // 选择视频封面文件
      isuploadPic: false,
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-shanghai",
      userId: "111",
      file: null,
      stsProgress: 0,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      statusText: "",
      pauseDisabled: true,
      uploader: null,
      uploadFileName: "",
      isEnd: false,
      uploadInfo: {},
      uploadingVideo: false,
      startUpload: false,
      countryList: [],
      topicList: [],
      categoryList: [],
      formRules: {},
      infoForm: {
        title: '',
        desc: '',
        time: new Date(),
        sid: undefined,
        category_id: undefined,
        topic_id: undefined,
        video_cover: '',
        video_url: ''
      },
      showCountryPicker: false,
      countryList: [],
      showCategoryPicker: false,
      categoryList: [],
      showTopicPicker: false,
      topicList: [],
      showTimePicker: false,
      firstTime: true,
      shotTime: new Date(),
      step: 1,
      videoInfo: ''
    }
  },
  computed: {
    ...mapGetters(['getPicWorkInfo']),
    ...mapGetters(['getUserInfo'])
  },
  created() {
    this.checkInfo()
    this.getCountryList()
    this.getCategoryList()
    if (!window.AliyunUpload) {
      this.loadScript("lib/aliyun-upload-sdk/lib/es6-promise.min.js");
      this.loadScript("lib/aliyun-upload-sdk/lib/aliyun-oss-sdk-6.13.0.min.js");
      this.loadScript("lib/aliyun-upload-sdk/aliyun-upload-sdk-1.5.2.min.js");
    }
    if (this.$route.query.works_id) {
      this.getData()
      this.stsProgress = 100
    }
  },
  methods: {
    checkInfo () {
      if (this.getUserInfo.volunteer_info == 0) {
        this.$router.push({
          path: '/mpage/m_userinfo'
        })
      }
    },
    // 动态加载oss库
    loadScript(url) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.body.appendChild(script);
    },
    // 国家picker
    onConfirmCountry (value) {
      this.infoForm.sid = value.sid
      this.showCountryPicker = false
    },
    // 分类picker
    onConfirmCategory (value) {
      this.infoForm.category_id = value.category_id
      this.showCategoryPicker = false
      this.getTopicList()
    },
    // 话题picker
    onConfirmTopic (value) {
      this.infoForm.topic_id = value.topic_id
      this.showTopicPicker = false
    },
    // 任职时间picker
    onConfirmTime (value) {
      this.firstTime = false
      this.infoForm.time = value
      this.shotTime = value
      this.showTimePicker = false
    },
    getCountryList () {
      this.$utils.get('/user/get-country-list').then(res => {
        this.countryList = res.data
      })
    },
    getCategoryList () {
      this.$utils.get('/works/getCategory').then(res => {
        this.categoryList = res.data
      })
    },
    getTopicList () {
      this.infoForm.topic_id = undefined
      this.$utils.get('/works/getTopic', {category_id: this.infoForm.category_id}).then(res => {
        this.topicList = res.data
      })
    },
    getworkInfo () {
      this.$utils.get('/works/getInfo', {works_id: this.$route.query.works_id}).then(res => {
        if (res.code == 1000) {
          this.picList = res.data.photo_list
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    },
    afterReadCover (file) {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      const _data = new FormData()
      _data.append('images', file.file)

      this.$utils.postFile('/user/upload/create-images', _data).then(res => {
        if (res.code == 1000) {
          this.infoForm.video_cover = res.data.url
        }
      })
    },
    afterRead (file) {
      this.videoChange(file)
    },
    videoChange (e) {
      this.stsProgress = 0;
      this.statusText = "";
      this.file = e.file;
      if (!this.file) {
        alert("请先选择需要上传的文件!");
        return;
      }
      this.uploadFileName = this.file.name;
      var userData = '{"Vod":{}}';
      if (this.uploader) {
        this.uploader.stopUpload();
        this.authProgress = 0;
        this.statusText = "";
      }
      this.uploader = this.createUploader();
      // 首先调用 uploader.addFile(event.target.files[i], null, null, null, userData)
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = false;
      this.isEnd = true;
    },
    // 开始上传
    stsUpload () {
      // 然后调用 startUpload 方法, 开始上传
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.uploadDisabled = true;
        this.pauseDisabled = false;
        this.startUpload = true
      }
    },
    createUploader() {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          self.videoInfo = uploadInfo.file.name
        },

        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 STSToken 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 用户需要自己获取 accessKeyId, accessKeySecret,secretToken
          // 下面的 URL 只是测试接口, 用于获取 测试的 accessKeyId, accessKeySecret,secretToken
          // let stsUrl = 'http://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateSecurityToken?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=67999yyuuuy&AppVersion=1.0.0'
          // axios.get(stsUrl).then(({data}) => {
          //   let info = data.SecurityTokenInfo
          //   let accessKeyId = info.AccessKeyId
          //   let accessKeySecret = info.AccessKeySecret
          //   let secretToken = info.SecurityToken
          //   uploader.setSTSToken(uploadInfo, accessKeyId, accessKeySecret, secretToken)
          // })

          self.$utils
            .get("/user/upload/create-media", {
              file_name: uploadInfo.file.name,
            })
            .then((res) => {
              if (res.code == 1000) {
                self.uploadInfo = res.data;
                const uploadAuth = res.data;
                uploader.setUploadAuthAndAddress(
                  uploadInfo,
                  uploadAuth.UploadAuth,
                  uploadAuth.UploadAddress,
                  uploadAuth.VideoId
                );
                self.stsUpload();
                self.uploadingVideo = true
              } else {
                Notify({ type: 'warning', message: res.msg })
              }
            });
          self.statusText = "文件开始上传...";
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
          self.statusText = "文件上传成功!";
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          // console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
          self.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          console.log(
            "Canceled file: " +
              uploadInfo.file.name +
              ", code: " +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          // console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
          let progressPercent = Math.ceil(progress * 100);
          self.stsProgress = progressPercent;
          self.statusText = "文件上传中...";
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          // console.log(uploadInfo)
          self.statusText = "文件上传完毕, 3s后关闭";
          self.isEnd = true;
          // setTimeout(() => {
          //   self.videoUploadStep = 3
          //   console.log(self.uploadInfo)
          self.infoForm.video_url = self.uploadInfo.VideoId
          // }, 3000)
        },
      });
      return uploader;
    },
    getData () {
      this.$utils.get('/works/getInfo', {works_id: this.$route.query.works_id}).then(res => {
        if (res.code == 1000) {
          let { title, desc, time, sid, category_id, topic_id, video_cover, video_url } = res.data
          this.infoForm.title = title
          this.infoForm.desc = desc
          this.infoForm.time = new Date(+time * 1000)
          this.firstTime = false
          this.infoForm.sid = sid
          this.infoForm.category_id = category_id
          this.infoForm.video_cover = video_cover
          this.infoForm.video_url = video_url
          this.$utils.get('/works/getTopic', {category_id: this.infoForm.category_id}).then(res => {
            this.topicList = res.data
            this.infoForm.topic_id = topic_id
          })
          this.getPlayAuth()
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    },
    getPlayAuth () {
      this.$utils.get('/works/getPlayAuth', {video_id: this.infoForm.video_url}).then(res => {
        if (res.code == 1000) {
          this.videoInfo = res.data.VideoMeta.Title
        }
      })
    },
    // 提交
    submitFun () {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      if (!this.infoForm.video_cover) {
        Notify({ type: 'warning', message: '请选择封面图' })
        return
      }
      if (!this.infoForm.title) {
        Notify({ type: 'warning', message: '标题不能为空' })
        return
      }
      if (!this.infoForm.sid) {
        Notify({ type: 'warning', message: '国家不能为空' })
        return
      }
      if (!this.infoForm.category_id) {
        Notify({ type: 'warning', message: '分类不能为空' })
        return
      }
      if (!this.infoForm.topic_id) {
        Notify({ type: 'warning', message: '话题不能为空' })
        return
      }
      if (!this.$route.query.works_id) {
        let param = {
          ...this.infoForm
        }
        this.$utils.postForm('/works/api/submitVideo', param).then(res => {
          if(res.code == 1000) {
            Notify({ type: 'success', duration: 1000, message: '作品提交成功!' })
            setTimeout(() => {
              this.$router.push({
                path: '/mpage/m_submit'
              })
            }, 1000)
          } else {
            Notify({ type: 'warning', message: res.msg })
          }
        })
      } else {
        let param = {
          works_id: this.$route.query.works_id,
          ...this.infoForm
        }
        this.$utils.postForm('/works/api/updateVideo', param).then(res => {
          if(res.code == 1000) {
            Notify({ type: 'success', duration: 1000, message: '修改成功!' })
            setTimeout(() => {
              this.$router.push({
                path: '/mpage/m_submit'
              })
            }, 1000)
          } else {
            Notify({ type: 'warning', message: res.msg })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.van-uploader {
  position: absolute;
  width: calc(100% - 1.4rem);
  z-index: 2;
  .van-uploader__upload {
    width: calc(100%);
    height: 7.57rem;
    margin: 0;
    opacity: 0;
  }
}
</style>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  overflow: hidden;
  .content {
    padding: .3rem .45rem 0 .45rem;
    box-sizing: border-box;
    .formWrap {
      background: #fff;
      min-height: calc(100vh - 5.85rem);
      padding: .7rem 0 0;
      // overflow: auto;
      padding-bottom: 1rem;
      position: relative;
      .add_img {
        width: 100%;
      }
      .upload_cover_wrap {
        padding: 0 .7rem;
        padding-bottom: .59rem;
        position: relative;
        .cover_con {
          position: relative;
          .change_cover {
            font-size: .39rem;
            color: #fff;
            background: rgba(0,0,0,.7);
            padding: 0 .2rem;
            height: .9rem;
            line-height: .9rem;
            text-align: center;
            position: absolute;
            right: 0;
            bottom: 0;
          }
          .add_img {
            width: 100%;
          }
        }
      }
      .upload_cover {
        background: rgba(0,0,0,.7);
        width: 100%;
        height: 7.57rem;
        position: absolute;
        top: .7rem;
        width: calc(100% - 1.4rem);
        font-size: 1.2rem;
        color: #fff;
        text-align: center;
        line-height: 7.57rem;
      }
      .add_tip {
        font-size: .45rem;
        color: #999;
        line-height: 1.5;
        margin-top: .25rem;
      }
    }
    .formItem {
      background: #fff;
      border-top: .01rem solid #ccc;
      padding: .4rem .78rem .4rem .7rem;
      box-sizing: border-box;
      line-height: 1.8;
      .formName {
        font-size: .6rem;
        color: #282828;
        float: left;
      }
      .formCon {
        float: right;
        width: 75%;
        height: 1.2rem;
        padding-right: 0.4rem;
        box-sizing: border-box;
        color: #282828;
        font-size: .45rem;
        text-align: right;
        &.conHolder {
          color: #999;
        }
        input {
          width: 100%;
          height: 1.2rem;
          color: #282828;
          display: block;
          background-color: transparent;
          border: 0;
          padding: 0;
          margin: 0;
          resize: none;
          text-align: right;
        }
      }
      .formIcon {
        float: right;
        .arrow {
          width: .3rem;
          margin-top: .35rem;
        }
        .calendar {
          width: .46rem;
          margin-top: .35rem;
        }
      }
      &.note {
        .formName {
          float: none;
        }
        .formCon {
          float: none;
          text-align: left;
          width: 100%;
          height: 3.5rem;
          padding: 0;
          input {
            text-align: left;
          }
          textarea {
            width: 100%;
            height: 3.5rem;
            border: 0;
            resize: none;
            padding: 0;
          }
        }
      }
      &.title {
        .formName {
          float: none;
        }
        .formCon {
          float: none;
          text-align: left;
          width: 100%;
          height: 2rem;
          padding: 0;
          input {
            text-align: left;
          }
          textarea {
            width: 100%;
            height: 2rem;
            border: 0;
            resize: none;
            padding: 0;
          }
        }
      }
    }
  }
  .submit_btn {
    width: 100%;
    height: 2.41rem;
    background-color: #333;
    color: #fff;
    font-size: .8rem;
    text-align: center;
    line-height: 2.41rem;
    // position: fixed;
    // bottom: 0;
    &.disable {
      background-color: #b2b3b3;
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #999;
  }
}
</style>
